export default __webpack_public_path__ + "static/media/UniversLTStd-Black.4a512420.otf";